<template>
    <v-container fluid class="grey lighten-5 my-0 px-0  py-0">
        <q-agent-lead-order-submenu></q-agent-lead-order-submenu>
        <v-row class="mx-5">
            <v-col cols=12 class="text-center">
                <q-lead-orders-by-state-data-table></q-lead-orders-by-state-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
//table data + search
import QLeadOrdersByStateDataTable from '@/components/datatables/LeadOrders/QLeadOrdersByStateDataTable.vue';
import QAgentLeadOrderSubmenu from '@/components/navigation/Submenus/QAgentLeadOrderSubmenu.vue';

export default {
    data() {
        return {
            //search: '',
        }
    },
    components: {
        QLeadOrdersByStateDataTable,
        QAgentLeadOrderSubmenu
    },
    methods: {

    },

}

</script>
